var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6525 27.5003L17.9025 27.8337C19.0275 29.3337 21.2775 29.3337 22.4025 27.8337L22.6525 27.5003M13.6382 22.9583L13.7243 23.1359C14.2774 24.2762 15.4335 25.0003 16.7009 25.0003H23.5516C24.6376 25.0003 25.6485 24.4455 26.2316 23.5292C27.0548 22.2358 26.8367 20.5391 25.7133 19.4958L25.6768 19.4618C24.914 18.7535 24.5385 17.7215 24.6676 16.6886L24.7215 16.2579C25.0262 13.8202 23.1254 11.667 20.6687 11.667H19.2496C16.7959 11.667 14.8975 13.8175 15.2018 16.2523L15.268 16.7813C15.3897 17.7556 15.0339 18.7287 14.3123 19.3946C13.3267 20.3041 13.0529 21.7517 13.6382 22.9583Z",
    stroke: "#A4A8AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellGray);
export default __webpack_public_path__ + "static/media/bell-gray.6cecf9ba3ae2250f4cd0eae5aaabe4a5.svg";
export { ForwardRef as ReactComponent };